import React, { useState } from 'react';
import { Box, Button, IconButton, Popover, Stack, Typography } from '@mui/material';

import { FlagCzRound, FlagSk } from '../icons';
import i18n from '@/i18n';

import { styles } from './styles.ts';

const languages = [
  { code: 'cs', label: 'Čeština', Flag: FlagCzRound },
  { code: 'sk', label: 'Slovensky', Flag: FlagSk },
];

export const LanguageSwitch = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [language, setLanguage] = useState(i18n.language);

  const open = Boolean(anchorEl);

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (lang: string) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    setAnchorEl(null);
  };

  // Match language code, handling cases like "cs-CZ" -> "cs"
  const currentLang = languages.find((l) => language.startsWith(l.code)) ?? languages[0];

  return (
    <Box sx={{ position: 'relative' }}>
      <IconButton
        onClick={handleToggle}
        sx={styles.button}
        aria-label="Přepnout jazyk"
        data-testid="language-switch-button"
        data-language={currentLang.code}
      >
        <Box sx={styles.flagIcon}>
          <currentLang.Flag />
        </Box>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={styles.popover}
        data-testid="language-switch-popover"
      >
        <Stack>
          {languages.map(({ code, label, Flag }) => {
            const isSelected = language.startsWith(code);

            return (
              <Button
                key={code}
                variant="text"
                onClick={() => handleSelect(code)}
                sx={isSelected ? styles.languageButtonSelected : styles.languageButton}
                data-testid={`language-option-${code}`}
                data-selected={isSelected}
              >
                <Stack direction="row" gap={1} alignItems="center">
                  <Box sx={styles.flagIcon}>
                    <Flag />
                  </Box>
                  <Typography sx={styles.languageLabel}>{label}</Typography>
                </Stack>
              </Button>
            );
          })}
        </Stack>
      </Popover>
    </Box>
  );
};
